import React, {useRef, useState} from 'react';
import Form from "../../components/form/Form";
import {useOpportunity} from "../../providers/OpportunityProvider";
import SpinLoader from "../../components/SpinLoader";
import TimeMaterialsDemo from "./components/TimeMaterialsDemo";

const roundHourlyRate = (rate) => {
    return Math.round((rate + Number.EPSILON) * 100) / 100
}
const AvailabilityRateEditTab = ({
                                     onUpdate = async () => true,
                                     showSteps,
                                     getStepActions = false
                                 }) => {

    const {
        opportunity,
        isDisabled,
        changeProps,
        onRequest,
        isUpdating
    } = useOpportunity();

    const editable = opportunity.canEditProposal();
    const mapping = (model = {}) => {
        if (model.confirmed_availability) {
            model.confirmed_avg_hours_per_period = opportunity.project_position.avg_hours_per_period;
            model.confirmed_started_at = opportunity.project_position.started_at;
        }else {
            if (typeof model.confirmed_started_at === 'string') {
                model.confirmed_started_at = new Date(model.confirmed_started_at)
            }
            if (!TB.isNaN(parseInt(model.confirmed_avg_hours_per_period))) {
                model.confirmed_avg_hours_per_period = parseInt(model.confirmed_avg_hours_per_period)
            }
        }
        return model;
    }

    const formRef = useRef(null);
    const fieldProps = ['hourly_rate', 'confirmed_started_at', 'confirmed_avg_hours_per_period']

    const buildModel = (fromModel = opportunity?.job_candidate) => {
        let model = TB.pick(fromModel, fieldProps);

        const sameHours = !TB.isDefined(model.confirmed_avg_hours_per_period) ||
            model.confirmed_avg_hours_per_period === opportunity.project_position.avg_hours_per_period;

        const sameDate = !TB.isDefined(model.confirmed_started_at) || TB.moment(opportunity.project_position.started_at).isSame(model.confirmed_started_at, 'day');

        model.confirmed_availability = sameHours && sameDate;

        return mapping(model)
    }
    const [formModel, setFormModel] = useState(buildModel());

    const availRateFields = () => {

        // let profileDiscipline = opportunity.profileDisciplineForTalent(auth);

        return [
            {
                fields: {
                    rateHeader: (
                        <div className="lg:flex flex-row items-center my-2 gap-6">
                            <h3 className="proposal-tab-header mr-2 mb-0 mt-0 whitespace-nowrap">
                                Bill Rate
                            </h3>
                            <p className="proposal-tab-subheader mb-0 mt-0">
                                A market competitive rate within the client’s budget will maximize your chances of
                                securing the project
                            </p>
                        </div>
                    )
                }
            },
            {
                className: 'hourly-rate-container field-section',
                fields: [
                    {
                        className: 'hourly-rate-fields field-section',
                        fields: {
                            hourly_rate_label: {
                                component: (
                                    <label className="rate-label col-form-label" htmlFor="hourly_rate">
                                        My Proposed Rate for this role
                                    </label>
                                ),
                                columns: 3,
                                style: styles.rowField,
                            },
                            hourly_rate: {
                                label: false,
                                type: 'number',
                                addonBefore: "$",
                                required: true,
                                columns: 4,
                                disabled: isDisabled,
                                style: styles.rowField,
                                addonAfter: (
                                    <span className="rate-note text-bold">
                                        per hour
                                    </span>
                                )
                            },

                            avg_rate_note: {
                                style: styles.field,
                                columns: 5,
                                component: opportunity.hasClientTargetRate() ? (
                                    <div className="proposal-rate-note">
                                        <i className="fa fa-info-circle"/>
                                        <p>
                                            The client has set a budget bill rate for this project:&nbsp;&nbsp;
                                            <b>{TB.formatCurrency(opportunity.project_position?.targetRate())} per hour</b>
                                        </p>
                                    </div>
                                ) : (
                                    <div className="proposal-rate-note">
                                        <i className="fa fa-info-circle"/>
                                        <p>
                                            The average rate on Wripple with similar roles and <b>6-10 years
                                            experience</b>:&nbsp;&nbsp;
                                            <b>{TB.formatCurrency(opportunity.project_position?.marketRate())} per
                                                hour</b>
                                        </p>
                                    </div>
                                )
                            },
                        }
                    },
                    {
                        className: 'profile-hourly-rate field-section',
                        fields: {
                            hourly_rate_difference: {
                                columns: 5,
                                style: {...styles.rowField, padding: 0},
                                component: (
                                    opportunity.differenceFromRequestedHourlyRate() > 0 ? (
                                        <div className="profile-rate-note difference-warning">
                                            <p>*</p>
                                            <p>
                                                Your bill rate is <strong>${opportunity.differenceFromRequestedHourlyRate()} per hour</strong>
                                                &nbsp;above the&nbsp;
                                                {!opportunity.hasClientTargetRate() ?
                                                    'Average Bill Rate for this role on Wripple' :
                                                    'Client Target Bill Rate for this role'
                                                }
                                            </p>
                                        </div>
                                    ) : <div/>
                                ),
                            }
                        }
                    },
                    {
                        className: 'profile-hourly-rate field-section',
                        fields: {
                            spacer: (
                                <div>
                                    <hr className="my-2"/>
                                </div>
                            ),
                        }
                    },
                    {
                        className: 'hourly-rate-fields field-section',
                        fields: {
                            hourly_rate_label: {
                                component: (
                                    <label className="rate-label col-form-label" htmlFor="hourly_rate">
                                        My Proposed Payout
                                    </label>
                                ),
                                columns: 3,
                                style: styles.rowField,
                            },
                            payout_info: {
                                columns: 9,
                                style: styles.rowField,
                                component: (
                                    <span className="payout">
                                        <span>
                                            {TB.isDefined(opportunity.estimated_payout_amount) && TB.formatCurrency(opportunity.estimated_payout_amount, false)}
                                        </span>
                                        <span className="payout-info">
                                            <strong>
                                                {`$ ${roundHourlyRate(parseFloat(opportunity.job_candidate?.hourly_rate))}`}
                                            </strong>
                                            {` per hr @ `}
                                            <strong>
                                                {`${parseInt(opportunity.job_candidate?.total_hours)} total hours`}
                                            </strong>
                                        </span>
                                        <span className="text-xxs font-semibold text-info">Time & Materials</span>
                                    </span>
                                )
                            }
                        }
                    }
                ]
            },


            {
                fields: {
                    spacer: (
                        <div>
                            <hr/>
                        </div>
                    ),
                    availHeader: (
                        <div className="lg:flex flex-row items-center my-2">
                            <h3 className="proposal-tab-header mr-2 mb-0 mt-0">
                                Availability
                            </h3>
                            <p className="proposal-tab-subheader mb-0 mt-0">
                                The data populated below reflects the client’s request.
                                Please confirm and/or update.
                            </p>
                        </div>
                    )
                }
            },
            {
                className: 'avail-fields field-section',
                fields: [
                    {
                        className: 'avail-field-row field-section',
                        fields: {
                            confirmed_availability: {
                                className: 'm-0',
                                label: (
                                    <span className="text-black" style={{fontWeight: "normal"}}>
                                        By checking this box, I can confirm that I am available to start
                                        <b> {TB.moment(opportunity.project_position.started_at).format('ll')} </b>
                                        and can work up to <b>{opportunity.project_position.avg_hours_per_period} hrs per
                                        week</b>
                                    </span>
                                ),
                                disabled: isDisabled,
                                type: 'checkbox',
                                required: false
                            },
                        }
                    },
                    {
                        className: TB.mapClass("avail-edit-note field-section", {
                            "isVisible": !formModel.confirmed_availability
                        }),
                        groupClass: "avail-edit-group",
                        fields: {
                            confirmed_availability: {
                                component: (
                                    <p className="text-bold mb-0">
                                        My proposed availability for this role is:
                                    </p>
                                ),
                            },
                        }
                    },
                    {
                        className: 'avail-field-row field-section',
                        fields: {
                            hourly_rate_label: {
                                component: (
                                    <label className="avail-label col-form-label" htmlFor="confirmed_started_at">
                                        Date I can start
                                    </label>
                                ),
                                style: { padding: '0 15px', marginBottom: 0, width: 'auto', flexBasis: 'unset' }
                            },
                            confirmed_started_at: {
                                label: false,
                                type: 'date',
                                required: true,
                                columns: 5,
                                disabled: isDisabled || formModel.confirmed_availability,
                                style: { padding: '0 15px', marginBottom: 0 },
                                minDate: opportunity.minDate(),
                                maxDate: opportunity.maxDate(),
                                datePickerProps: {
                                    // activeStartDate: opportunity.requestedDate(),
                                    showFixedNumberOfWeeks: true,
                                    tileClassName: ({activeStartDate, date, view}) => {
                                        return TB.moment(opportunity.requestedDate())
                                            .isSame(date, 'day') ? 'target-date' : (
                                            (date >= opportunity.minDate() && date <= opportunity.maxDate()) ? 'active-range' : ''
                                        )
                                    }
                                },
                                onDateSelected: async (date) => {

                                    console.log('onDateSelected', date);

                                    let updatedModel = {
                                        confirmed_started_at: date
                                    }
                                    setFormModel({
                                        ...formModel,
                                        ...updatedModel
                                    })
                                    formRef?.current.updateInputsWithValue(updatedModel)

                                },
                                showCalendar: false
                            },
                        },
                    },
                    {
                        className: 'avail-field-row field-section',
                        fields: {
                            hourly_rate_label: {
                                component: (
                                    <label className="avail-label col-form-label"
                                           htmlFor="confirmed_avg_hours_per_period">
                                        I am available
                                    </label>
                                ),
                                style: { padding: '0 15px', marginBottom: 0, width: 'auto', flexBasis: 'unset' },
                            },
                            confirmed_avg_hours_per_period: {
                                label: false,
                                className: 'field hrs_per_week',
                                disabled: isDisabled || formModel.confirmed_availability,
                                type: 'number',
                                required: true,
                                columns: 5,
                                style: { padding: '0 15px', marginBottom: 0 },
                                validation: {
                                    rules: {
                                        availableHoursValidation: function (model, value) {
                                            let min = parseInt(value);
                                            if (TB.isNumber(min) && min < 1) {
                                                return "Must be greater than 0 hours";
                                            } else if (TB.isNumber(min) && min > opportunity.project_position.avg_hours_per_period) {
                                                return `Must be less than or equal to ${opportunity.project_position.avg_hours_per_period} hours`;
                                            }
                                            return true
                                        },
                                        isInt: true
                                    }
                                },
                                addonAfter: (
                                    <span className="rate-note text-bold">
                                        hours per week.
                                    </span>
                                )
                            },
                        },
                    }
                ]

            },
        ];
    }


    const hasFormModelChanged = () => {
        let opp = buildModel();
        let model = buildModel(formModel);
        return !TB.isEqual(opp, model)
    }

    const resetForm = async () => {
        let model = buildModel()

        model = mapping(model);
        if (model.confirmed_availability) {
            await TB.wait(200);
            await formRef?.current.updateInputsWithValue({
                confirmed_avg_hours_per_period: opportunity.project_position.avg_hours_per_period,
                confirmed_started_at: opportunity.project_position.started_at
            })
        }

        await formRef.current.forceReset(model);
        await formRef.current.formRef.current.formsyForm.setFormPristine(true);
        return setFormModel(model);
    }

    const submitForm = async () => {
        let invalid = formRef.current.forceValidate(formModel);
        if (invalid) {
            console.log('invalid', invalid)
            return;
        }
        let success = await onUpdate({job_candidate: {...formModel}, talent_proposed_at: opportunity.talent_proposed_at || new Date()})

        if (success) {
            await resetForm();
        }
    }
    return (
        <SpinLoader isLoading={isUpdating}>
            {/* <h2 className="text-info text-xl pb-4">Time & Materials</h2> */}
            <h2 className="text-xl pb-4">
                Type of Contract: <span className="text-info">Time & Materials</span>
            </h2>

            {getStepActions && getStepActions(
                'Please confirm your bill rate and availability to work on the project below',
                submitForm
            )}

            <div className="opp-talent-proposal-form">
                <Form
                    ref={formRef}
                    background={"transparent"}
                    mapping={mapping}
                    onSubmit={submitForm}
                    submitButton={false}
                    isDisabled={isDisabled}
                    model={formModel}
                    fields={availRateFields()}
                    className={
                        TB.mapClass({
                            'no-edit': !editable
                        })
                    }
                    onChange={model => {
                        let reset = !formModel.confirmed_availability && model.confirmed_availability;

                        setFormModel(mapping({
                                ...formModel, ...model
                            }
                        ))

                        if (reset) {
                            return formRef?.current.updateInputsWithValue({
                                confirmed_avg_hours_per_period: opportunity.project_position.avg_hours_per_period,
                                confirmed_started_at: opportunity.project_position.started_at
                            })
                        }

                    }}>
                    {editable && !showSteps && (
                        <div className="mt-3 flex flex-row justify-end">
                            <button type="submit" className="btn btn-primary mr-3"
                                    disabled={isDisabled || !hasFormModelChanged()}>
                                Save
                            </button>
                            <button className="btn btn-outline-dark"
                                    type="button" onClick={resetForm}
                                    disabled={isDisabled || !hasFormModelChanged()}>
                                Cancel
                            </button>
                        </div>
                    )}
                </Form>


                {/*<TimeMaterialsDemo/>*/}
            </div>

        </SpinLoader>
    );
};

const styles = {
    fieldSectionCol: {
        flexDirection: 'column',
        alignItems: 'stretch'
    },
    fieldSection: {
        margin: '0 -15px',
        flexDirection: 'row'
    },
    field: {
        padding: 0,
    },
    rowField: {padding: '0 15px', marginBottom: 0}
};


export default AvailabilityRateEditTab;